function directive($compile, $location, $http, $state, getData, $interval, $window, ngDialog, timeFormat, usSpinnerService) {
    return {
        replace: true,
        template: `<div id="sTable">`,
        link: function ($scope, elem, attrs) {
            $scope.tableComplete = true;
            // close dialog on open
            ngDialog.close();
            if (!$scope.page.settings.get('toggleVal')) {
                $scope.togVal = 1;
                $scope.byteOffset = 7;
            } else {
                $scope.byteOffset = 1;
                $scope.togVal = 1048576;
                if ($scope.page.settings.get('toggleVal') === "KB") {
                    $scope.byteOffset = 2.5;
                    $scope.togVal = 1024;
                }
            }
            // connect local scope to the timeFormat service
            $scope.timeFormat = timeFormat;
            // Leave the following lists empty because views are not ready, keep the previous arrays just in case are needed in the future. 
            // let custom_ioc_list = ['resp_ip', 'orig_ip', 'ip','filename', 'file_name', 'file', 'md5', 'sha1', 'sha256', 'top_domain', 'domain', 'host', 'subdomain'];
            // let whitelist_list = ['ioc_rule', 'seen_indicator'];
            let custom_ioc_list = [];
            let whitelist_list = [];
            let virustotal_list = ['ioc_rule'];
            $scope.custom_ioc_click = false;
            $scope.ioc_rule_click = false;
            $scope.virustotal_click = false;

            $scope.twoDecimal = function (num) {
                return Math.round(num*1000)/1000;
            }
            $scope.breakdown = function (a, b) {
                a = Number(a);
                b = Number(b);
                if ((a === 0) && (b === 0)) {
                    return 50;
                }
                return Math.round((a/(a+b))*100);
            }
            $scope.floatBreakdown = function (a, b)
            {
                let outputLeft = ((a / (a + b)) * 100).toFixed(2);
                let outputRight = (100 - outputLeft).toFixed(2);

                return (a === 0 && b === 0) ? { left: 50.00, right: 50.00 } : { left: outputLeft, right: outputRight };
            };


            let tableItemLimit = 20;
            if ($scope.page.settings.get('tableItemLimit')) {
                tableItemLimit = $scope.page.settings.get('tableItemLimit');
            }

            // create a refrence object for settings to compare against - NOTE these are the default settings set in the controller
            let columnRefrence = {};

            // this function the returns styled, but stripped dowm version of the table's TDs to be used in the table modal
            let nakedColumnItems = function (column) {
                switch (column.select) {
                    case 'time':
                    case 'first_seen':
                    case 'last_seen':
                    case 'last_run':
                    case 'compile_ts':
                    case 'certificate_not_valid_after':
                    case 'certificate_not_valid_before':
                        return '{{timeFormat(row.value.'+column.select+', \'tables\')}}';
                    case 'feed':
                        return '<div class="firstColumn"><span>{{::row.value.'+column.select+'}}</span></div>';
                    case 'custom_type':
                        return '<ioc-attribute type="type" name="{{::row.value.'+column.select+'}}"/>';
                    case 'custom_rule':
                        return '<ioc-attribute type="rule" name="{{::row.value.'+column.select+'}}"/>';
                    case 'l7_proto':
                        return '<div app-replace name="{{::row.value.'+column.select+'}}"></div>';
                    case 'resp_cc':
                    case 'server_cc':
                    case 'orig_cc':
                        return '<div style="min-width:50px"><div class="f32"><span class="flag {{row.value.'+column.select+' === \'N/A\' ?  \'iana\' : row.value.'+column.select+'.toLowerCase()}}"></span></div></div>';
                    case 'ioc_severity':
                        return '<div ng-if="::row.value.'+column.select+' != 0 && row.value.'+column.select+' != \'-\' "><div sev-replace name="{{::row.value.'+column.select+'}}"></div></div><div ng-if="row.value.'+column.select+' == 0 || row.value.'+column.select+' == \'-\'">-</div>';
                    case 'resp_asn_name':
                    case 'orig_asn_name':
                    case 'server_asn_name':
                        return '<section ng-if="::row.value.'+column.select+' === \'- (0)\' || row.value.'+column.select+' === \'- (-)\'">-</section><section ng-if="::row.value.'+column.select+' !== \'- (0)\' && row.value.'+column.select+' !== \'- (-)\'">{{::row.value.'+column.select+'}}</section>';
                    case 'file_size':
                    case 'size':
                    case 'bytes_orig':
                    case 'bytes_resp':
                        return '{{twoDecimal(row.value.'+column.select+'/togVal)}}';
                    case 'orig_stealth':
                    case 'resp_stealth':
                        return '<section ng-if="::row.value.'+column.select+' > 0"><span style="color:#000" class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i><i style="color:#f2f2f2" class="fa fa-shield fa-stack-1x fa-inverse"></i></span></section>';
                    case 'proxy_blocked':
                            return '<section ng-if="::row.value.proxy_blocked > 0"><span style="color:#E71010 " class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i><i style="color:#f2f2f2" class="fa fa-times fa-stack-1x fa-inverse"></i></span></section>';
                            // (IF WE RE ADD PROXY === 0)
                            // <section ng-if="::row.value.proxy_blocked <= 0"><span class="iconstroke fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i><i style="color:#f2f2f2" class="fa fa-check fa-stack-1x fa-inverse"></i></span></section>
                    case 'breakdown':
                        return '<span class="breakdown">'+
                                '<span class="orig"  ng-class="{\'blank\': ((row.value.bytes_resp == 0) && (row.value.bytes_orig == 0))}" style="width:{{breakdown(row.value.bytes_orig,row.value.bytes_resp)}}%;">{{breakdown(row.value.bytes_orig,row.value.bytes_resp)}}%</span>'+
                                '<span class="resp"  ng-class="{\'blank\': ((row.value.bytes_resp == 0) && (row.value.bytes_orig == 0))}" style="width:{{breakdown(row.value.bytes_resp,row.value.bytes_orig)}}%;">{{breakdown(row.value.bytes_resp,row.value.bytes_orig)}}%</span>'+
                                '</span>';
                    case 'subdomain_breakdown':
                        return `<span class="breakdown">
                                    <span class="orig"  ng-class="{\'blank\': ((row.value.subdomain_total == 0) && (row.value.subdomain_queries == 0))}" style="min-width: 1%; max-width: 99%; width:{{floatBreakdown(row.value.subdomain_total, row.value.subdomain_queries).left}}%;">{{floatBreakdown(row.value.subdomain_total, row.value.subdomain_queries).left}}%</span>
                                    <span class="resp"  ng-class="{\'blank\': ((row.value.subdomain_total == 0) && (row.value.subdomain_queries == 0))}" style="min-width: 1%; max-width: 99%; width:{{floatBreakdown(row.value.subdomain_total, row.value.subdomain_queries).right}}%;">{{floatBreakdown(row.value.subdomain_total, row.value.subdomain_queries).right}}%</span>
                                </span>`;
                    default:
                        return column.value;
                }
            }
            function constructTable(identifiers) {
                // stuff refrence object for use below
                for (let c = 0, len = $scope.main.dataObjects[identifiers.key].settings.columns.length; c < len; c++) {
                    columnRefrence[$scope.main.dataObjects[identifiers.key].settings.columns[c].select] = $scope.main.dataObjects[identifiers.key].settings.columns[c];
                }
                // columns logic
                $scope.columns = [];
                let newColumns = [];
                let prefix = '';
                if ($state.current.name === 'pages.main.search') {
                    prefix = angular.copy($scope.main.currentMode); // add mode to table prefix
                }
                // $scope.page.settings.set(prefix+'table-columnConfig', false)
                let settingsColumns = $scope.page.settings.get(prefix+'table-columnConfig');
                if (settingsColumns) {
                    // stuff any columns that are in our refrence AND are display true in the settings into our column obj
                    let columnsInSettingsDictionary = {}; // create lookup to iterate over and see if any new columns to append to end
                    settingsColumns.forEach(function (setting) {
                        let key = Object.keys(setting)[0];
                        if ((setting[key]) && (columnRefrence.hasOwnProperty(key))) {
                            $scope.columns.push(columnRefrence[key]);
                        }
                        columnsInSettingsDictionary[key] = true; // value doesn't matter here, just doing a key lookup below
                    })
                    for (let item in columnRefrence) {
                        let key = columnRefrence[item].select;
                        // if not in settings and default view is true, push it to new columns array
                        if ((!columnsInSettingsDictionary.hasOwnProperty(key)) && (columnRefrence[item].dView)) {
                            newColumns.push(columnRefrence[item]);
                        }
                    }
                    // append any new columns to our existing column array
                    $scope.columns.push.apply($scope.columns, newColumns);
                } else {
                // if no settings exist, loop through and replace the empty columns array with the settings array already defined
                    for (let c = 0, len = $scope.main.dataObjects[identifiers.key].settings.columns.length; c < len; c++) {
                        if ($scope.main.dataObjects[identifiers.key].settings.columns[c].dView) {
                            $scope.columns.push($scope.main.dataObjects[identifiers.key].settings.columns[c]);
                        }
                    }
                }

                let tdWrapper = function (innerText, column) {
                    let td = '<td class="noselect" ng-right-click="rightClicked($event, {value: row.value.'+column.select+', key: \''+column.select+'\', title: \''+column.title+'\' }, row)">';
                    td += innerText;
                    td += '</td>';
                    return td;
                }
                let cells = '';
                for (let i = 0, len = $scope.columns.length; i < len; i++) {
                    // hide stealth if user is not authorized
                    if ((($scope.columns[i].select === 'orig_stealth') || ($scope.columns[i].select === 'resp_stealth')) && ($scope.global.user.settings_global.stealth === false)) {
                        $scope.columns.splice(i, 1);
                        len = $scope.columns.length;
                    }
                    // hide proxy if user is not authorized
                    if (($scope.columns[i].select === 'proxy_blocked') && ($scope.global.user.settings_global.proxy_blocked === false)) {
                        $scope.columns.splice(i, 1);
                        len = $scope.columns.length;
                    }
                    // active defense if user is not authorized
                    if (($scope.columns[i].select === 'active_defense') && ($scope.global.user.settings_global.active_defense === false)) {
                        $scope.columns.splice(i, 1);
                        len = $scope.columns.length;
                    }
                    switch ($scope.columns[i].select) {
                        case 'time':
                        case 'first_seen':
                            var tdTxt = '';
                           if ($scope.columns[i].hasOwnProperty('link')) {
                                tdTxt += '<button class="btnTableDate2015" ng-click=\'::generateLink(row, '+i+')\'>'+
                                    nakedColumnItems($scope.columns[i])+
                                '</button>';
                            } else {
                                tdTxt += '<div class=\'tableDate2015\'>'+nakedColumnItems($scope.columns[i])+'</div>';
                            }
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'last_seen':
                        case 'last_run':
                        case 'compile_ts':
                        case 'certificate_not_valid_after':
                        case 'certificate_not_valid_before':
                            var tdTxt = nakedColumnItems($scope.columns[i]);
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'feed':
                            var tdTxt = nakedColumnItems($scope.columns[i]);
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'l7_proto':
                            var tdTxt = nakedColumnItems($scope.columns[i]);
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'resp_cc':
                        case 'server_cc':
                        case 'orig_cc':
                            var tdTxt = nakedColumnItems($scope.columns[i]);
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'ioc_severity':
                            var tdTxt = nakedColumnItems($scope.columns[i]);
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'resp_asn_name':
                        case 'orig_asn_name':
                        case 'server_asn_name':
                            var tdTxt = nakedColumnItems($scope.columns[i]);
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'file_size':
                        case 'size':
                        case 'bytes_orig':
                        case 'bytes_resp':
                            var tdTxt = nakedColumnItems($scope.columns[i]);
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'subdomain_breakdown':
                        case 'breakdown':
                            var tdTxt = nakedColumnItems($scope.columns[i]);
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'ioc_count':
                            var tdTxt = '';
                            tdTxt += '<section ng-if="(row.value.ioc_count > 0) && checkSev()">';
                                if ($scope.columns[i].hasOwnProperty('link')) {
                                    tdTxt += '<a class="cellioccount" ng-click="::generateLink(row, '+i+')"> {{::row.value.ioc_count}} </a>';
                                } else {
                                    tdTxt += '<div class="cellioccount"> {{::row.value.ioc_count}} </div>';
                                }
                            tdTxt += '</section>'+
                            '<section ng-if="(row.value.ioc_count > 0) && !(checkSev())">'+
                                '{{::row.value.ioc_count}}'+
                            '</section>'+
                            '<section ng-if="row.value.ioc_count == 0">'+
                                '{{::row.value.ioc_count}}'+
                            '</section>';
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'orig_stealth':
                        case 'resp_stealth':
                            var tdTxt = nakedColumnItems($scope.columns[i]);
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'group':
                            var tdTxt = '{{(row.value.'+$scope.columns[i].select+' === "N/A" || row.value.'+$scope.columns[i].select+' == 0) ?  "-" : row.value.'+$scope.columns[i].select+'}}';
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'proxy_blocked':
                            var tdTxt = nakedColumnItems($scope.columns[i]);
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'Archive': // ioc notifications pages
                            var tdTxt = '';
                            tdTxt += '<button class="btnArchive2015" ng-click="::generateButton(\'Archive\', row)">Archive</button>';
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'Restore': // ioc archive page
                            var tdTxt = '';
                            tdTxt += '<button class="btnRestore2015" ng-click="::generateButton(\'Restore\', row, \'/api/actions/restore\')">Restore</button>';
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'Delete': // custom ioc pages
                            var tdTxt = '';
                            tdTxt += '<button class="btnArchive2015" ng-click="::generateButton(\'Delete\', row, \''+$scope.columns[i].link.call+'\')">Delete</button>';
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'Edit': // custom ioc pages
                            var tdTxt = '';
                            tdTxt += '<div ng-click="::generateButton(\'Edit\', row, \''+$scope.columns[i].link.call+'\')" style="cursor:pointer" id="editServices"><svg height="30" width="70"><path transform="translate(0,6)" style="fill:#555555;" d="M15.3,16c0.6,0,1.2,0.1,1.7,0.4c0.7-0.8,1.2-1.8,1.6-2.8c-1.4-0.6-2.3-2-2.3-3.6c0-1.6,1-3,2.3-3.6c-0.4-1-0.9-2-1.6-2.8C16.5,3.9,15.9,4,15.3,4c-2.1,0-3.9-1.7-4-3.8C10.7,0.1,10,0,9.3,0s-1.4,0.1-2,0.2C7.2,2.3,5.5,4,3.3,4C2.7,4,2.1,3.9,1.6,3.6C0.9,4.4,0.4,5.4,0,6.4C1.4,7,2.3,8.4,2.3,10c0,1.6-1,3-2.3,3.6c0.4,1,0.9,2,1.6,2.8C2.1,16.1,2.7,16,3.3,16c2.1,0,3.9,1.7,4,3.8c0.7,0.1,1.3,0.2,2,0.2s1.4-0.1,2-0.2C11.4,17.7,13.2,16,15.3,16zM5.3,10c0-2.2,1.8-4,4-4s4,1.8,4,4c0,2.2-1.8,4-4,4S5.3,12.2,5.3,10z"/></path></svg></div>'
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'custom_type': // custom_ioc page
                        case 'custom_rule': // custom_ioc page
                            var tdTxt = nakedColumnItems($scope.columns[i]);
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'ioc_alert': // custom_ioc page
                            var tdTxt = '';
                            tdTxt += '{{row.value.'+$scope.columns[i].select+' == 0 ? "No" : "Yes"}}';
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'active_defense': // custom_ioc page
                            var tdTxt = '';
                            tdTxt += '{{row.value.'+$scope.columns[i].select+' ? "Yes" : "No"}}';
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        case 'active': // ioc_feeds page
                            var tdTxt = '';
                            tdTxt += '<div class="checkBox-slider">'
                            tdTxt += '<label ng-class="{\'greenLabel\': row.value.active}"><input type="checkbox" name="switch" id="switch" ng-model="row.value.active" ng-checked="row.value.active != 0" ng-true-value="1" ng-false-value="0" ng-click="::generateButton(\'active\', row, \''+$scope.columns[i].link.call+'\')" /><span>&nbsp;</span></label>';
                            tdTxt += '</div>';
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                        default:
                            var tdTxt = '';
                            if ($scope.columns[i].hasOwnProperty('link')) {
                                tdTxt += '<a ng-click="::generateLink(row, '+i+')" class="isLink">{{::row.value.'+$scope.columns[i].select+'}}</a>';
                            } else if (typeof $scope.columns[i].linkcheck !== 'undefined') {
                                tdTxt += '<a ng-click="::checkLink(row, '+i+')" class="isLink">{{::row.value.'+$scope.columns[i].select+'}}</a>';
                            } else {
                                tdTxt += '{{row.value.'+$scope.columns[i].select+' === "N/A" ?  "-" : row.value.'+$scope.columns[i].select+'}}';
                            }
                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
                            break;
                    }
                    ///////////////////////
                    /// LINK MANAGEMENT ///
                    ///////////////////////
                    $scope.generateLink = function (data, columnIndex) {
                        var searchObj = {}, type;
                        // add url date params to new page if they exist
                        if ($location.$$search.start && $location.$$search.end) {
                            searchObj.start = $location.$$search.start;
                            searchObj.end = $location.$$search.end;
                        }
                        // loop through defined links to genereate search object
                        if ($scope.columns[columnIndex].link.val.length > 0) {
                            for (var i in $scope.columns[columnIndex].link.val) {
                                searchObj[$scope.columns[columnIndex].link.val[i]] = data.value[$scope.columns[columnIndex].link.val[i]];
                            }
                        }
                        if ($scope.main.dataObjects[identifiers.key].settings.columns[columnIndex].link.table_name) {
                            searchObj["table_name"] = $scope.main.dataObjects[identifiers.key].settings.columns[columnIndex].link.table_name;
                        }
                        type = angular.copy($scope.columns[columnIndex].link.type);
                        if (type === "search") { // IF SENDING TO SEARCH PAGE!
                            let params = { include: [], time: null}
                            let obj = {from : "",title : "", value : ""}
                            for (let c in $scope.columns) {
                                if (searchObj[$scope.columns[c].select]) {
                                    obj.from = $scope.columns[c].select
                                    obj.title = $scope.columns[c].title
                                    obj.value = searchObj[$scope.columns[c].select]
                                    params.include.push(angular.copy(obj))
                                }
                            }
                            if (($location.$$search.hasOwnProperty('start')) && ($location.$$search.hasOwnProperty('end'))) {
                                params.time = {
                                    start: $location.$$search.start,
                                    end: $location.$$search.end
                                }
                            }
                            $state.go('pages.main.search', params);
                        } else {
                            $scope.main.cleanup().then(function () {
                                // finally hit page being requested with search params
                                $location.path(type).search(searchObj);
                            })
                        }
                    }
                }

                var html = `
                <div id="contextMenu" class="clearfix" style="position:absolute;display:none">
                    <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu" style="display:block; margin-bottom:5px">
                        <li role="menuitem"><a ng-click="contextClicked('include')">Include</a></li>
                        <li role="menuitem"><a ng-click="contextClicked('exclude')">Exclude</a></li>
                        <li role="menuitem"><a ng-click="contextClicked('search')">Instant Search</a></li>
                        <li role="menuitem" ng-show="custom_ioc_click"><a ng-click="contextClicked('custom_ioc')">Custom IOC</a></li>
                        <li role="menuitem" ng-show="ioc_rule_click"><a ng-click="contextClicked('whitelist')">Whitelist</a></li>
                        <li role="menuitem" ng-show="virustotal_click"><a ng-click="contextClicked('virustotal')">VirusTotal Search</a></li>
                    </ul>
                </div>
                <button ng-click="generateCsv()" ng-show="main.dataObjects['`+identifiers.key+`'].settings.columns" class="btnRaised2015" href="">Export</button>
                <div class="title2015">{{main.dataObjects['`+identifiers.key+`'].settings.title}} - {{timeFormat(page.loadStart, 'tableMinMax')}} - {{timeFormat(page.loadEnd, 'tableMinMax')}}
                    <span class="complete" ng-show="page.complete && tableComplete">
                        <svg fill="none" stroke="none" height="20" width="20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-293 385 24 24" xml:space="preserve">
                        <path fill="none" stroke="none" d="M-293,385h24v24h-24V385z"/>
                        <path fill="#00A800" d="M-281,387c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10S-275.5,387-281,387z M-283,402l-5-5l1.4-1.4l3.6,3.6l7.6-7.6l1.4,1.4L-283,402z"/></svg>
                    </span>
                    <span class="complete">
                        <div class="spinner-table spinner" us-spinner spinner-key="spinner-`+identifiers.id+`" spinner-theme="table" spinner-start-active="true"></div>
                    </span>
                    <div ng-click="toggleBytes()" class="toggleValue" ng-hide="main.dataObjects['`+identifiers.key+`'].settings.hideToggleBytes">{{(!page.settings.get('toggleVal')) ? 'B' : page.settings.get('toggleVal')}}</div>
                </div>
                <table id="sevTable">
                    <th ng-repeat="col in columns" ng-click="sortCol(col.select)" ng-class="{ \'firstTitleINVALID\': $first }" class="tableTitles2015">
                        <a>{{::col.title}}</a>
                    </th>
                    <tr ng-if="row.value != false && row.value.failed_ssl !== 'Self signed certificate'" ng-repeat="row in main.dataObjects['`+identifiers.key+`'].settings.data" ng-click="openRow(row, $event)">
                        `+ cells +`
                    </tr>
                    <tr ng-if="row.value != false && row.value.failed_ssl === 'Self signed certificate'" ng-repeat="row in main.dataObjects['`+identifiers.key+`'].settings.data" ng-click="openRow(row, $event)" style="background-color: #f88b1220; font-weight: bold;">
                        `+ cells +`
                    </tr>
                </table>
                <div class="table-paginator-container">
                    <div class="table-paginator">
                        <span ng-click="prevPage()">< Previous </span>  |
                        <span ng-click="setPage(1)" ng-class="{\'active\': (main.dataObjects['`+identifiers.key+`'].settings.currentPage === 1)}" >1</span>
                        <span class="dots" ng-show="main.dataObjects['`+identifiers.key+`'].settings.currentPage > 4"> ... </span>
                        <span ng-click="setPage(a)" class="middlePages" ng-class="{\'active\': (main.dataObjects['`+identifiers.key+`'].settings.currentPage === a)}" ng-repeat="a in range(5)">{{a}}</span>
                        <span class="dots" ng-show="(main.dataObjects['`+identifiers.key+`'].settings.totalPages - main.dataObjects['`+identifiers.key+`'].settings.currentPage) > 4"> ... </span>
                        <span ng-click="setPage(main.dataObjects['`+identifiers.key+`'].settings.totalPages)" ng-hide="(main.dataObjects['`+identifiers.key+`'].settings.totalPages === 1)" ng-class="{\'active\': (main.dataObjects['`+identifiers.key+`'].settings.currentPage === main.dataObjects['`+identifiers.key+`'].settings.totalPages)}">{{main.dataObjects['`+identifiers.key+`'].settings.totalPages}}</span> |
                        <span ng-click="nextPage()"> Next ></span>
                        <br/>
                        Displaying Rows
                        {{(((main.dataObjects['`+identifiers.key+`'].settings.currentPage - 1) * getTableLimit())+1) || 0}}
                        to {{(getMin((main.dataObjects['`+identifiers.key+`'].settings.currentPage * getTableLimit()), main.dataObjects['`+identifiers.key+`'].settings.dataSize)) || 0}}
                        <span class="plain-text" ng-if="getTableLimit() < main.dataObjects['`+identifiers.key+`'].settings.dataSize">out of {{(main.dataObjects['`+identifiers.key+`'].settings.dataSize) || 0}} </span>
                        <br/>
                        Items per page <span ng-class="{\'active\': (getTableLimit() === 20)}" ng-click="changeItemsPerPage(20)">20</span> |
                        <span ng-class="{\'active\': (getTableLimit() === 50)}" ng-click="changeItemsPerPage(50)">50</span> |
                        <span ng-class="{\'active\': (getTableLimit() === 100)}" ng-click="changeItemsPerPage(100)">100</span> |
                        <span ng-class="{\'active\': (getTableLimit() === 200)}" ng-click="changeItemsPerPage(200)">200</span>
                    </div>
                </div>
                </div>`; // this div opens at the top of the link function
                return elem.append($compile(html)($scope));
            }
            // on table init begin drawing columns
            $scope.$on('table-build', function (event, identifiers) {
                // empty the element on build
                elem.empty();
                // set data array length to zero, just in case there are loading errors
                $scope.main.dataObjects[identifiers.key].settings.data = [];
                return constructTable(identifiers);
            })
            $scope.$on('init', function (event, identifiers) {
                if (identifiers.id !== attrs.uid) { return }
                //////////////////////////
                /////// PAGINATION ///////
                //////////////////////////
                // this resets the total counts of data and total pages.
                (function setTotals() { // this runs after any filter is added or removed
                    $scope.main.dataObjects[identifiers.key].settings.dataSize = $scope.main.dataObjects[identifiers.key].group.size();
                    $scope.main.dataObjects[identifiers.key].settings.totalPages = Math.ceil($scope.main.dataObjects[identifiers.key].settings.dataSize / tableItemLimit);
                })();
                function asc() {
                    let x = $scope.main.dataObjects[identifiers.key].settings.dataSize - ($scope.main.dataObjects[identifiers.key].settings.currentPage*tableItemLimit);
                    let y = ($scope.main.dataObjects[identifiers.key].settings.dataSize - ($scope.main.dataObjects[identifiers.key].settings.currentPage*tableItemLimit)) + tableItemLimit;
                    // cant have a negative value in the first arg of a slice, so set any negatives to 0
                    if (x < 0) {
                        x = 0;
                    }
                    updateData(x, y);
                }
                function desc() {
                    updateData(($scope.main.dataObjects[identifiers.key].settings.currentPage-1)*tableItemLimit, $scope.main.dataObjects[identifiers.key].settings.currentPage*tableItemLimit);
                }

                let generateTableRows = function (start, end) {
                    return (function () {
                        return $scope.main.dataObjects[identifiers.key].group.order(function (p) {
                            if (_.isArray($scope.main.dataObjects[identifiers.key].settings.sort.col)) {
                                let arr = $scope.main.dataObjects[identifiers.key].settings.sort.col.map(i => {
                                    let result = p[i];
                                    if (i === "breakdown" || i === "subdomain_breakdown") { // need to convert all to number because search page is raw table => strings
                                        result = Number(Number(p.bytes_orig)/(Number(p.bytes_orig)+Number(p.bytes_resp)));
                                        if ((Number(p.bytes_orig) === 0) && (Number(p.bytes_resp) === 0)) {
                                            result = Number(0.5);
                                        }
                                    } else {
                                        if ($scope.main.dataObjects[identifiers.key].settings.hasOwnProperty('columnSpec')) {
                                            if ($scope.main.dataObjects[identifiers.key].settings.columnSpec[i] === 0) {
                                                result = Number(p[i]);
                                            } else {
                                                result = p[i];
                                            }
                                        }
                                    }
                                    return result;
                                })
                                return arr;
                            } else {
                                let result = p[$scope.main.dataObjects[identifiers.key].settings.sort.col];
                                if ($scope.main.dataObjects[identifiers.key].settings.hasOwnProperty('columnSpec')) {
                                    if ($scope.main.dataObjects[identifiers.key].settings.columnSpec[$scope.main.dataObjects[identifiers.key].settings.sort.col] === 0) {
                                        result = Number(p[$scope.main.dataObjects[identifiers.key].settings.sort.col]);
                                    } else {
                                        result = p[$scope.main.dataObjects[identifiers.key].settings.sort.col];
                                    }
                                }
                                return result;
                            }
                        }).top(Infinity).filter(function (obj) {
                            if (obj.value.visible === true) {
                                return true;
                            }
                        }).slice(start, end);
                    })()
                }
                function updateData(start, end) {
                    if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
                        $scope.main.dataObjects[identifiers.key].settings.data = generateTableRows(start, end);
                    } else {
                        $scope.main.dataObjects[identifiers.key].settings.data = generateTableRows(start, end).reverse();
                    }
                }

                $scope.setPage = function (pageNumber) {
                    if ($scope.main.dataObjects[identifiers.key].settings.currentPage !== pageNumber) {
                        $scope.main.dataObjects[identifiers.key].settings.currentPage = pageNumber;
                        if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
                            desc();
                        } else {
                            asc();
                        }
                    }
                }
                $scope.range = function (n) {
                    let arr = [];
                    let diff = 0;
                    if (!$scope.main.dataObjects[identifiers.key]) { return }
                    if (typeof $scope.main.dataObjects[identifiers.key].settings === 'undefined') { return }
                    if ($scope.main.dataObjects[identifiers.key].settings === null) { return }
                    let min = $scope.main.dataObjects[identifiers.key].settings.currentPage - 2;
                    let max = $scope.main.dataObjects[identifiers.key].settings.currentPage + 2;

                    if (min < 2) {
                        diff = 2 - min;
                        min = 2;
                        max += diff;
                        if (max > $scope.main.dataObjects[identifiers.key].settings.totalPages-1) {
                            max = $scope.main.dataObjects[identifiers.key].settings.totalPages-1;
                        }
                    }
                    if (max > $scope.main.dataObjects[identifiers.key].settings.totalPages) {
                        diff = max - $scope.main.dataObjects[identifiers.key].settings.totalPages -1;
                        max = $scope.main.dataObjects[identifiers.key].settings.totalPages -1;
                        min -= diff+1;
                        if (min < 2) {
                            min = 2;
                        }
                    }
                    for (let i = min; i <= max; i++) {
                        arr.push(i)

                    }
                    return arr;
                };
                $scope.changeItemsPerPage = function (number) {
                    tableItemLimit = number;
                    if (tableItemLimit === 20) {
                        $scope.page.settings.set('tableItemLimit', false)
                    } else{
                        $scope.page.settings.set('tableItemLimit', tableItemLimit)
                    }
                    if ($scope.main.dataObjects[identifiers.key].settings.currentPage > Math.ceil($scope.main.dataObjects[identifiers.key].settings.dataSize / tableItemLimit)) {
                        $scope.main.dataObjects[identifiers.key].settings.dataSize = $scope.main.dataObjects[identifiers.key].group.size();
                        $scope.main.dataObjects[identifiers.key].settings.currentPage = Math.ceil($scope.main.dataObjects[identifiers.key].settings.dataSize / tableItemLimit);
                    }
                    $scope.main.dataObjects[identifiers.key].settings.totalPages = Math.ceil($scope.main.dataObjects[identifiers.key].settings.dataSize / tableItemLimit);
                    if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
                        desc();
                    } else {
                        asc();
                    }
                }
                $scope.getMin = function (val1, val2) {
                    return Math.min(val1,val2);
                }
                $scope.getTableLimit = function () {
                    return tableItemLimit;
                }
                $scope.nextPage = function () {
                    if ($scope.main.dataObjects[identifiers.key].settings.currentPage !== $scope.main.dataObjects[identifiers.key].settings.totalPages) {
                        $scope.main.dataObjects[identifiers.key].settings.currentPage++;
                        if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
                            desc();
                        } else {
                            asc();
                        }
                    }
                }
                $scope.prevPage = function () {
                    if ($scope.main.dataObjects[identifiers.key].settings.currentPage !== 1) {
                        $scope.main.dataObjects[identifiers.key].settings.currentPage--;
                        if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
                            desc();
                        } else {
                            asc();
                        }
                    }
                }
                // change filter direction and fire slicing function
                $scope.sortCol = function (col) {
                    $scope.main.dataObjects[identifiers.key].settings.render = { once: true, has: true }
                    // set the default sort value which is just a string with the column select
                    $scope.main.dataObjects[identifiers.key].settings.sort.col = col;
                    // append time to the col IF:
                    // - the clicked column isn't time
                    // - time exists as a possible column
                    if (col !== 'time') { // if clicked item is not time
                        let timeExists = false; // assume time doesn't exist in the table
                        $scope.main.dataObjects[identifiers.key].settings.columns.forEach(function (d) {
                            if (d.select === 'time') {
                                timeExists = true;
                            }
                        })
                        // if we've found time in the table settings
                        if (timeExists) {
                            if ($scope.main.dataObjects[identifiers.key].settings.hasOwnProperty('columnSpec')) {
                                // BUT only append time to sort if the column contains only numbers
                                if (!_.isNumber($scope.main.dataObjects[identifiers.key].settings.columnSpec[col]) || (col === 'ioc_severity')) // NOTE: we want the time to be grouped on ioc severity, because it comes in as a nuimber
                                    $scope.main.dataObjects[identifiers.key].settings.sort.col = [col, 'time']; // sort becomes an array with time in it
                            }
                        }
                    }
                    if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
                        $scope.main.dataObjects[identifiers.key].settings.sort.direction = '+';
                        asc();
                    } else {
                        $scope.main.dataObjects[identifiers.key].settings.sort.direction = '-';
                        desc();
                    }
                }

                //////////////////////////////
                //////  TABLE BUTTONS   //////
                //////////////////////////////
                $scope.generateButton = function (type, data, call) {
                    switch (type) {
                        case 'active':
                            $scope.page.toggleActive(data.value);
                        break;
                        case 'Delete':
                            $scope.page.deleteTarget(data.value);
                        break;
                        case 'Edit':
                            $scope.page.editTarget(call, data.value);
                        break;
                    }
                }

                ////////////////////////////////////////
                /////// RIGHT CLICK CONTEXT MENU ///////
                ////////////////////////////////////////
                var $contextMenu = $("#contextMenu");
                $scope.rightClicked = function (elm, data, row) {
                    $contextMenu = $("#contextMenu");
                    if (!$scope.main.dataObjects[identifiers.key].settings.searchCategories.hasOwnProperty(data.key)) { return }
                    $scope.virustotal_click = false;
                    if (virustotal_list.indexOf(data.key) > -1) {
                        if (row.value.ioc_type.toLowerCase().indexOf("domain") > -1) {
                            $scope.virustotal_click = true;
                        }
                    }
                    $scope.ioc_rule_click = false;
                    if (whitelist_list.indexOf(data.key) > -1) {
                        $scope.ioc_rule_click = true;
                    }
                    $scope.custom_ioc_click = false;
                    if (custom_ioc_list.indexOf(data.key) > -1) {
                        $scope.custom_ioc_click = true;
                    }
                    $contextMenu.css({
                        display: "block",
                        left: elm.pageX,
                        top: elm.pageY
                    });
                    $scope.contextClicked = function (inex) {
                        switch (inex) {
                            case 'include':
                                $scope.main.filterItem(data.key, data.value, 'include', data.title)
                                break;
                            case 'exclude':
                                $scope.main.filterItem(data.key, data.value, 'exclude', data.title)
                                break;
                            case 'virustotal':
                                // if (row.value.ioc_type.toLowerCase().indexOf("domain") > -1) {
                                    var win = window.open('https://www.virustotal.com/latest-scan/http://'+data.value, '_blank'); // opens new tab
                                    win.focus();
                                // }
                                break;
                            case 'search':
                            case 'custom_ioc':
                            case 'whitelist':
                                let params = {
                                    include: [{
                                        from: data.key,
                                        title: data.title,
                                        value: data.value
                                    }],
                                    time: null
                                }
                                if (($location.$$search.hasOwnProperty('start')) && ($location.$$search.hasOwnProperty('end'))) {
                                    params.time = {
                                        start: $location.$$search.start,
                                        end: $location.$$search.end
                                    }
                                }
                                $state.go('pages.main.'+inex, params);
                                break;
                        }
                    }
                }
                // close context menu on any click
                $(document).on("click", function () {
                    $contextMenu.hide();
                });

                /////////////////////////////
                /////// CSV EXPORTING ///////
                /////////////////////////////
                $scope.generateCsv = function () {
                    let csv = "", csvArray = [];
                    //2d array sort for sorting data for csv print
                    var sortFunction = function (a, b) {
                        var tableSort;
                        if ($scope.sortIndex) {
                            tableSort = [[$scope.sortIndex, $scope.sortDir]];
                        } else {
                            tableSort = $scope.data.table.settings.params.sort;//default
                        }
                        var index = tableSort.col;
                        var direction = tableSort.direction;
                        if (a[index] === b[index]) {
                            return 0;
                        } else {
                            if (direction == "asc") {
                                return (a[index] < b[index]) ? -1 : 1
                            } else {
                                return (a[index] > b[index]) ? -1 : 1
                            }
                        }
                    }
                    var download = function (strData, strFileName, strMimeType) {
                        var D = document,
                            a = D.createElement("a");
                            strMimeType = strMimeType;

                        if (navigator.msSaveBlob) { // IE10
                            return navigator.msSaveBlob(new Blob([strData], {type: strMimeType}), strFileName);
                        }

                        if ('download' in a) { //html5 A[download]
                            let csvData = new Blob([strData], { type: strMimeType });
                            let csvUrl = URL.createObjectURL(csvData);
                            a.href =  csvUrl;
                            a.setAttribute("download", strFileName);
                            a.innerHTML = "downloading...";
                            D.body.appendChild(a);
                            setTimeout(function () {
                                a.click();
                                D.body.removeChild(a);
                            }, 66);
                            return true;
                        }

                        //do iframe dataURL download (old ch+FF):
                        var f = D.createElement("iframe");
                        D.body.appendChild(f);
                        f.src = "data:" +  strMimeType   + "," + encodeURIComponent(strData);
                        setTimeout(function () {
                            D.body.removeChild(f);
                        }, 333);
                        return true;
                    }
                    let dim = $scope.main.dataObjects[identifiers.key].dimension.top(Infinity);
                    let col = $scope.main.dataObjects[identifiers.key].settings.columns;
                    // Remove duplicated rows from the CSV
                    // This is called here because it hasn't been found the reason why are the rows being duplicated
                    dim = _.uniqWith(dim, _.isEqual);
                    for (let c in col) {
                        csv += '"'+col[c].title+'"'+",";
                    }
                    csv += '\n';
                    // csvArray.push(csvRow);
                    // csvArray.push(" ");
                    for (let i in dim) {
                        for (let c in col) {
                            if (col[c].select === "time") {
                                csv += '"'+timeFormat(dim[i][col[c].select], 'tables')+'"'+",";
                            } else {
                                csv += '"'+dim[i][col[c].select]+'"'+",";
                            }
                        }
                        csv += '\n'
                        // csvArray.push(csvRow);
                    }
                    var fileName = $location.path().replace("/", "");
                    fileName += "_"+$scope.main.dataObjects[identifiers.key].settings.title;
                    //create the download
                    download(csv, fileName+"_CSV.csv", "text/csv");
                };

                ////////////////////////////////////
                /////// BYTE TOGGLE SETTINGS ///////
                ////////////////////////////////////
                $scope.toggleBytes = function () {
                    let toggle;
                    if ($scope.page.settings.get('toggleVal') === "KB") {
                        toggle = "MB";
                        $scope.togVal = 1048576;
                        $scope.byteOffset = 1;
                    } else if ($scope.page.settings.get('toggleVal') === "MB") {
                        toggle = false;
                        $scope.togVal = 1;
                        $scope.byteOffset = 7;
                    } else {
                        toggle = "KB";
                        $scope.togVal = 1024;
                        $scope.byteOffset = 2.5;
                    }
                    // update settings
                    $scope.page.settings.set('toggleVal', toggle).then(function () {
                        for (let m in $scope.main.dataObjects) {
                            if (!$scope.main.dataObjects[m].launched) { continue }
                            // if (!$scope.main.dataObjects[m].settings.refresh) { continue }
                            if ($scope.main.dataObjects[m].settings.get.call === "table") { continue }
                            $scope.$broadcast('updatedData', $scope.main.dataObjects[m].settings.id);
                        }
                    })
                }
                // set variables and init functions
                $scope.main.dataObjects[identifiers.key].settings.currentPage = 1; // set current page
                if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
                    updateData(0, tableItemLimit); // just load the first values by default, no need to run the extra desc function
                } else {
                    asc();
                }

                ///////////////////////////////////////////
                /////// VERTICAL TABLE POPUP CONFIG ///////
                ///////////////////////////////////////////
                $scope.openRow = function (row, el) {
                    let clickedElem = el.target;
                    if (clickedElem.tagName.toLowerCase() !== 'td') { return }
                    let model = this;
                    model.editMode = false; // edit mode is false by default
                    // this is a variable checking if ANY change was made while tables were open,
                    // so we can use it later to potential saving
                    let edited = false;
                    let refrenceOrder = '';
                    angular.copy($scope.columns).map(function (c) {
                        refrenceOrder += c.select;
                    })
                    // sortable settings
                    model.tableItemsConfig = {
                        // group: 'foobar',
                        animation: 150,
                        onSort: function (event) {
                            model.makeChange(event.models);
                        }
                    }
                    // limit the row information to what is defined in the table columns spec (in the page controller)
                    // add prefix for search mode so we can customize different tables
                    let prefix = '';
                    if ($state.current.name === 'pages.main.search') {
                        prefix = angular.copy($scope.main.currentMode); // add mode to table prefix
                    }
                    let cc = $scope.page.settings.get(prefix+'table-columnConfig');
                    model.info = [];
                    if (cc) {
                        // make title dictionary
                        for (let l = 0, len = cc.length; l < len; l++) {
                            let item = {};
                            let key = Object.keys(cc[l])[0];
                            // skip if the saved item isnt in the table config anymore
                            if (key !== "breakdown" || key !== "subdomain_breakdown") {
                                if (!row.value.hasOwnProperty(key)) { continue }
                                if (!columnRefrence.hasOwnProperty(key)) { continue }
                            }
                            item.select = key;
                            item.title = columnRefrence[key].title;
                            item.value = row.value[key];
                            item.active = cc[l][key];
                            model.info.push(item);
                        }
                    } else {
                        // IF COLUMNS ARE NOT DEFINED
                        for (let c = 0, len = $scope.main.dataObjects[identifiers.key].settings.columns.length; c < len; c++) {
                            // extra safety to make sure the data we're asking for is actually in the row
                            if ((row.value.hasOwnProperty($scope.main.dataObjects[identifiers.key].settings.columns[c].select))
                                || ($scope.main.dataObjects[identifiers.key].settings.columns[c].select === "breakdown")
                                || ($scope.main.dataObjects[identifiers.key].settings.columns[c].select === "subdomain_breakdown"))  {
                                let item = {};
                                item.title = $scope.main.dataObjects[identifiers.key].settings.columns[c].title;
                                item.select = $scope.main.dataObjects[identifiers.key].settings.columns[c].select;
                                item.value = row.value[$scope.main.dataObjects[identifiers.key].settings.columns[c].select];
                                // check to see if the column is active
                                item.active = false;
                                $scope.columns.forEach(function (col) {
                                    if (col.select === item.select) {
                                        // mark active true if a matching item is found in $scope.columns (to get currently active)
                                        item.active = true;
                                    }
                                })
                                model.info.push(item);
                            }
                        }
                    }
                    // makeChange compares and sets $scope.columns according to any changes that have been made
                    model.makeChange = function (list) {
                        let listString = '';
                        let arr = [];
                        list.forEach(function (l) {
                            if (l.active === true) {
                                listString += l.select;
                                arr.push(l);
                            }
                        })
                        if (refrenceOrder !== listString) {
                            edited = true;
                        } else {
                            edited = false;
                        }
                    }
                    model.startEdit = function () {
                        $scope.main.safeApply(function () { // the safe apply makes sure angular always sees the change
                            model.editMode = true;
                        })
                    }
                    model.doneEdit = function () {
                        $scope.tableComplete = false;
                        usSpinnerService.spin();
                        model.editMode = false;
                        if (edited) {
                            let editedList = angular.copy(model.info);
                            let settingsToSave = [];
                            // reset the refrence order to the current settings
                            refrenceOrder = '';
                            editedList.forEach(function (l) {
                                if (l.active) {
                                    refrenceOrder += l.select;
                                }
                                // push to our save array in case we do save it below
                                let obj = {};
                                obj[l.select] = l.active;
                                settingsToSave.push(obj);
                            })
                            // check original controller settings to see if we need to save new settings or just remove old ones
                            let controllerColumnOrder = '';
                            for (let c = 0, len = $scope.main.dataObjects[identifiers.key].settings.columns.length; c < len; c++) {
                                if ($scope.main.dataObjects[identifiers.key].settings.columns[c].dView) {
                                    controllerColumnOrder += $scope.main.dataObjects[identifiers.key].settings.columns[c].select;
                                }
                            }
                            let redrawTable = function () {
                                // empty the element on build
                                elem.empty();
                                constructTable(identifiers);
                            }
                            // add prefix for search mode so we can customize different tables
                            let prefix = '';
                            if ($state.current.name === 'pages.main.search') {
                                prefix = angular.copy($scope.main.currentMode); // add mode to table prefix
                            }
                            if (controllerColumnOrder === refrenceOrder) {
                                // remove the settings if the refrence matches our controller settings
                                $scope.page.settings.set(prefix+'table-columnConfig', false).then(function () {
                                    redrawTable();
                                })
                            } else {
                                $scope.page.settings.set(prefix+'table-columnConfig', settingsToSave).then(function () {
                                    redrawTable();
                                    const spinner = document.getElementsByClassName('spinner-table spinner')[0];
                                    if (spinner) {
                                        usSpinnerService.stop();
                                        $scope.tableComplete = true;
                                    }
                                });
                            }
                            // remove the edited status
                            edited = false;
                        }
                    }

                    // create string that the modal compiler will loop through on open to determine
                    // what div rows should be drawn on compile
                    let normalValueString = '', editValueString = '';
                    model.info.forEach(function (item, index) {
                        normalValueString += '<div class="span8" style="overflow-wrap: break-word" ng-if="(i.select == \''+item.select+'\')">'+nakedColumnItems(item, item.value)+'</div>';
                        editValueString += '<div class="span8" style="overflow-wrap: break-word" ng-if="(i.select == \''+item.select+'\')">'+nakedColumnItems(item, item.value)+'</div>';
                    })
                    let template = `
                        <div class="tableModal">
                            <div class="tableContainer">
                                <div class="tableHeader">
                                    <a ng-click="startEdit()" ng-if="!editMode"> <i class="fa fa-cog"></i></a>
                                    <a ng-click="doneEdit()" ng-if="editMode">Done <i class="fa fa-check"></i></a>
                                </div>
                                <div ng-if="editMode">
                                    <li class="row-fluid title-row">
                                        <div class="span1 drag-handle">Reorder</div>
                                        <div class="span2">Title</div>
                                        <div class="span8">Value</div>
                                        <div class="span1 column-toggle">Display</div>
                                    </li>
                                    <ul ng-sortable="tableItemsConfig" class="table-items">
                                        <li class="row-fluid" ng-repeat="i in info">
                                            <div style="cursor: pointer" class="span1 drag-handle">☰</div>
                                            <div class="span2">{{::i.title}}</div>
                                            `+editValueString+`
                                            <div class="span1 column-toggle">
                                                <div class="checkBox-slider">
                                                    <input type="checkbox" name="switch" class="switch" ng-model="i.active" ng-checked="i.active" />
                                                    <label for="switch" class="label"></label>
                                                    <label ng-class="{'greenLabel': i.active}"><input type="checkbox" name="switch" id="switch" ng-model="i.active" ng-change="makeChange(info)" ng-checked="i.active" /><span>&nbsp;</span></label>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <!-- NON EDIT MODE -->
                                <div ng-show="!editMode">
                                    <li class="row-fluid title-row">
                                        <div class="span3">Title</div>
                                        <div class="span9">Value</div>
                                    </li>
                                    <ul class="table-items">
                                        <li class="row-fluid" ng-repeat="i in info">
                                            <div class="span3">{{::i.title}}</div>
                                            `+normalValueString+`
                                            <div class="span1"><i ng-show="!i.active" alt="Column not displayed in table on page." class="fa fa-eye-slash"></i></div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    `;
                    ngDialog.open({
                        template: template,
                        plain: true,
                        appendTo: '.page-content',
                        scope: model,
                        preCloseCallback: function () {
                            // use the doneEdit function since it already checks for changes
                            //model.doneEdit();
                        }
                    });
                }

                ////////////////////////////////
                /////// UPDATE FUNCTIONS ///////
                ////////////////////////////////
                $scope.$on('updatedData', function (event, id, skipGroupRedraw) {
                    if (id !== identifiers.id) { return } // only run when it sees its id has filtered
                    if ((typeof skipGroupRedraw === 'undefined')) {
                        // rerun grouping
                        $scope.main.dataObjects[identifiers.key].group = $scope.main.dataObjects[identifiers.key].settings.group($scope.main.dataObjects[identifiers.key].dimension);
                    }
                    if (typeof skipGroupRedraw === "object") {
                        $scope.main.dataObjects[identifiers.key].group = $scope.main.dataObjects[identifiers.key].settings.group($scope.main.dataObjects[identifiers.key].dimension);
                        if (skipGroupRedraw.complete) {
                            $scope.page.complete = true;
                        }
                    }
                    $scope.main.dataObjects[identifiers.key].settings.dataSize = 50
                    // this is set to stop any redaw of the rows if there is no reduce happening
                    let redrawRows = true;
                    // set the angular data array
                    $scope.main.safeApply(function () {
                        // skip reduce/redraw on anything with grouping of only 'id'
                        if ($scope.main.dataObjects[identifiers.key].settings.hasOwnProperty('render')) {
                            if ($scope.main.dataObjects[identifiers.key].settings.data.length === tableItemLimit) {
                                if (($scope.main.dataObjects[identifiers.key].settings.render.once) && ($scope.main.dataObjects[identifiers.key].settings.render.has === false)) {
                                    $scope.main.dataObjects[identifiers.key].settings.render.has = true;
                                } else {
                                    redrawRows = false;
                                }
                            }
                        }
                        if (redrawRows) {
                            $scope.main.dataObjects[identifiers.key].settings.data = generateTableRows(0, tableItemLimit);
                        }
                        // update total data size
                        $scope.main.dataObjects[identifiers.key].settings.dataSize = $scope.main.dataObjects[identifiers.key].group.all().filter(function (obj) {
                            if (obj.value.visible === true) {
                                return true;
                            }
                        }).length;
                        $scope.main.dataObjects[identifiers.key].settings.totalPages = Math.ceil($scope.main.dataObjects[identifiers.key].settings.dataSize / tableItemLimit);
                    })
                    // append style to each of the td's with dropdowns a class
                })
            })
        }
    }
}

directive.$inject = ['$compile', '$location', '$http', '$state', 'getData', '$interval', '$window', 'ngDialog', 'timeFormat', 'usSpinnerService'];
module.exports = directive;



/** WEBPACK FOOTER **
 ** ./src/pages/directives/table/table.js
 **/